import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { LocaleModule } from 'src/app/core/locale/locale.module';
import { RoutingModule } from 'src/app/core/routing/routing.module';
import { AnalyticsModule } from '../../core/analytics/analytics.module';
import { DynamicFormModule } from '../../feature/dynamic-form/dynamic-form.module';
import { VerifyRoutingModule } from './verify-routing.module';
import { VerifyComponent } from './verify.component';
import { SpinnerModule } from 'src/app/feature/spinner/spinner.module';

@NgModule({
	declarations: [VerifyComponent],
	imports: [
		CommonModule,
		RoutingModule,
		LocaleModule,
		DynamicFormModule,
		AnalyticsModule,
		VerifyRoutingModule,
		SpinnerModule,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class VerifyModule {}
